<template>
  <div class="page page-padding" style="background: #F1F1F1;">
    <div class="form-item-group">
      <div class="form-item">
        <div class="form-item__label">服务类型</div>
        <div class="form-item__value">预约车检</div>
      </div>
    </div>

    <div class="form-item-group">
      <div class="form-item">
        <div class="form-item__label">预约站点</div>
        <div class="form-item__value" >{{storeName}}</div>
      </div>
      <div class="form-item">
        <div class="form-item__label">站点地址</div>
        <div class="form-item__value">
          {{address}}
        </div>
      </div>
      <div class="form-item">
        <div class="form-item__label">检测费用</div>
        <div class="form-item__value" v-if="serviceConfig.length==0">
          线下到站支付
        </div>
        <div class="form-item__value price" v-if="serviceConfig.length > 0">
          <span style="font-size: 10px">￥</span>{{serviceConfig[0].price + serviceConfig[0].servicePrice}}
        </div>
      </div>
    </div>
    <div class="form-item-group">
      <div class="form-item">
        <div class="form-item__label">预约日期</div>
        <div class="form-item__value" @click="()=>{this.calendarShow=true}">{{ pockCarDateFormat}}</div>

      </div>
      <div class="form-item">
        <div class="form-item__label">预约时间</div>
        <div class="form-item__value" @click="()=>{this.planTimeShow=true}">{{ planTimeFormat}}</div>
      </div>
    </div>

    <van-button round class="book-next-btn" :disabled="nextBtnDisabled" @click="settlement">下一步</van-button>
    <van-popup v-model="planTimeShow" position="bottom">
      <van-datetime-picker
              v-model="planTime"
              type="time"
              title="选择时间"
              :min-hour="9"
              :max-hour="16"
              :filter="pickCarTimeFilter"
              @confirm="(value)=>{this.planTime = value;this.planTimeShow=false;}"
              @cancel="()=>{this.planTimeShow=false}"
      />
    </van-popup>

    <van-popup v-model="areaPopupShow" position="bottom">
      <van-area :area-list="areaList" @confirm="areaConfirm" @cancel="() => {this.areaPopupShow = false}"/>
    </van-popup>
    <van-calendar v-model="calendarShow" :min-date="minDate" color="#7EB375" @confirm="calendarConfirm"/>
  </div>
</template>

<script>
  import {Calendar, Button, DatetimePicker, Popup, Area, Notify} from 'vant';
  import dateUtil from "../../utils/dateUtil";
  import areaList from '../../config/areaList';

  export default {
    name: "bookOrder",
    components: {
      vanCalendar: Calendar,
      vanButton: Button,
      vanDatetimePicker: DatetimePicker,
      vanPopup: Popup,
      vanArea:Area
    },
    data() {
      return {
        areaList,
        storeName: null,
        address: '',
        calendarShow: false,
        planTimeShow: false,
        areaPopupShow: false,
        planDate: null,
        planTime: null,
        pickCarPrice:0,
        inspectPrice:0,
        nextBtnDisabled:false,
        serviceConfig:[],
        minDate:null,
      }
    },
    computed: {
      pockCarDateFormat() {
        if (this.planDate == null) {
          return "请选择预约日期";
        }
        return dateUtil.format(this.planDate, "yyyy-MM-dd")
      },
      planTimeFormat() {
        if (this.planTime == null) {
          return "请选择预约时间";
        }
        return this.planTime;
      },
    },
    methods: {
      settlement(){
        if(this.planDate == null){
          Notify("请选择接车日期")
          return;
        }
        if(this.planTime == null){
          Notify("请选择接车时间")
          return;
        }
        this.$store.commit("SET_ORDER",{
          storeId:this.$route.params.merchantId,
          planTime:this.planTime,
          planDate:dateUtil.format(this.planDate,'yyyy-MM-dd'),
          configId:this.serviceConfig.length == 0 ? null : this.serviceConfig[0].configId,
          orderType:17,
        });
        this.$router.push("/settlement");
      },
      areaConfirm(areaArr) {
        this.location = areaArr.map(item => item.name).join("");
        this.areaPopupShow = false;
        this.getPickCarConfig(areaArr[0].name, areaArr[1].name);
      },
      pickCarTimeFilter(type, options) {
        if (type === 'minute') {
          return options.filter((option) => option % 15 === 0);
        }
        return options;
      },
      calendarConfirm(date) {
        this.planDate = date;
        this.calendarShow = false;
      },
      loadOutletDetail(){
        const id = this.$route.params.merchantId;
        this.$http.get(`/store/${id}`)
          .then(resp => {
            if(resp.success){
              this.storeName = resp.data.storeName;
              const {province,city,district,address} = resp.data;
              this.address=`${province}${city}${district}${address}`
            }
          })
          .catch(error => {
            console.log(error);
          })
      },
      getStoreServiceConfig(){
        const id = this.$route.params.merchantId;
        this.$http.get(`/store/${id}/service/config`)
          .then(resp => {
            if(resp.success){
              this.serviceConfig = resp.data;
            }
          })
          .catch(error => {
            console.log(error);
          })
      }
    },
    created() {
      this.loadOutletDetail();
      this.getStoreServiceConfig();
      const now  = new Date();
      const minDate = new Date(now);
      minDate.setDate(now.getDate() + 1);
      this.minDate = minDate;
    }
  }
</script>

<style lang="less" scoped>
  .form-item-group {
    background: #FFF;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    padding: 0 22.5px;
    width: 345px;
    margin: 0 auto 10px;
    box-sizing: border-box;
  }

  .form-item {
    display: flex;
    align-items: center;
    height: 54px;

    border-bottom: 1px solid #ebedf0;
    box-sizing: border-box;

    &__label {
      color: #393939;
      font-weight: 500;
      font-size: 18px;
    }

    &__value {
      margin-left: 25px;
      flex: 1;
      display: flex;
      align-items: center;
      font-size: 15px;
      &.price{
        color:#E54A4A;
        font-size: 18px;
      }
      input {
        border: none;
        line-height: 54px;
        height: 50px;
        width: 100%;
      }
    }
  }

  .book-next-btn {
    background: #7EB375;
    color: #FFF;
    font-weight: bold;
  }
</style>
